export enum TipoUsuario {
    MASTER = "Master",
    ADMIN = "Admin",
    AUXILIAR_DE_ESTOQUE = 'Auxiliar de Estoque'
}